//
//
//
//
//
//
//
//

export default {
    created(){
        this.nowDate=new Date().getFullYear()
    },
    data: () => ({
        nowDate:''
    }),
}
